import gql from "graphql-tag";
import { image } from "../fragments";
import { Game, GameContent, gamePreview } from "./_common";
import { IImagePreview } from "../gallery";

export interface OutcomeQuiz extends Game<OutcomeQuizContent> {
    __typename: "OutcomeQuiz";
}

export interface OutcomeQuizContent extends GameContent {
    nextQuestionButton: string;
    showResultButton: string;
    restartButton: string;
    shareMessage: string;
    shareYourResult: string | null;
    questions: OutcomeQuizQuestionContent[];
    summaries: OutcomeQuizSummaryContent[];
}

export interface OutcomeQuizQuestionContent {
    id: string;
    text: string;
    answerImage: IImagePreview | null;
    image: IImagePreview | null;
    variants: OutcomeQuizVariantContent[];
}

export interface OutcomeQuizVariantContent {
    id: string;
    text: string;
    summaryWeights: number[];
    pickedCount: number | null;
}

export interface OutcomeQuizSummaryContent {
    title: string;
    text: string;
    image: IImagePreview | null;
    pickedCount: number | null;
}
export const GET_OUTCOME_QUIZ = gql`
    query getOutcomeQuiz($id: OutcomeQuizID!, $langCode: LangCode) {
        game: outcomeQuiz(id: $id) {
            id
            slug
            date
            updatedAt
            featured
            contentLangs
            usersCount
            content(langCode: $langCode) {
                title
                metaTitle
                keywords
                text
                metaDescription
                image {
                    ...image
                }
                startButton
                nextQuestionButton
                showResultButton
                restartButton
                shareMessage
                shareYourResult
                questions {
                    id
                    text
                    image {
                        ...image
                    }
                    answerImage {
                        ...image
                    }
                    variants {
                        id
                        text
                        summaryWeights
                        pickedCount
                    }
                }
                summaries {
                    title
                    text
                    pickedCount
                    image {
                        ...image
                    }
                }
            }
            recommendedGames {
                ...gamePreview
            }
            promoApps(platforms: [ios, android, huawei]) {
                id
                title
                icon {
                    sourceUrl
                    sizes
                }
                marketUrl
                marketId
                platform
            }
            engagementInfo {
                facebook
                messenger
                twitter
                telegram
                whatsapp
                native
            }
            topics {
                id
                content(langCode: $langCode) {
                    title
                }
            }
        }
    }
    ${image}
    ${gamePreview}
`;

export interface PickOutcomeQuizQuestionVariantVariables {
    input: {
        quizId: string;
        variantId: string;
    };
}

export const PICK_OUTCOME_QUIZ_QUESTION_VARIANT = gql`
    mutation pickOutcomeQuizQuestionVariant(
        $input: PickOutcomeQuizQuestionVariantInput!
    ) {
        pickOutcomeQuizQuestionVariant(input: $input) {
            picked
        }
    }
`;

export interface SaveOutcomeQuizResultVariables {
    input: {
        quizId: string;
        result: number;
    };
}

export const SAVE_OUTCOME_QUIZ_RESULT = gql`
    mutation saveOutcomeQuizResult($input: SaveOutcomeQuizResultInput!) {
        saveOutcomeQuizResult(input: $input) {
            saved
        }
    }
`;
